import viewImage from '../images/working/view.jpg';
import questionImage from '../images/working/question.jpg';
import puzzleImage from '../images/working/puzzle.jpg';
import collabImage from '../images/working/collab.jpg';
import postitsImage from '../images/working/postits.jpg';
import changeImage from '../images/working/change.jpg';

export const processPhases = [
  {
    id: 'align',
    phase: '01',
    title: 'Align',
    label: 'Framing the problem',
    body: 'I align leadership, product, and delivery around the problem, the constraints, and the outcomes that matter.',
    outputs: ['Shared problem framing', 'Stakeholder alignment', 'Success criteria'],
    image: viewImage,
  },
  {
    id: 'discover',
    phase: '02',
    title: 'Discover',
    label: 'Understanding reality',
    body: 'I uncover how the service actually works across users, teams, and systems.',
    outputs: ['Insight themes', 'Stakeholder ecosystem maps', 'Service gaps'],
    image: questionImage,
  },
  {
    id: 'synthesize',
    phase: '03',
    title: 'Synthesize',
    label: 'Making sense of complexity',
    body: 'I translate research into structured insight, identifying patterns, tensions, and opportunities.',
    outputs: ['Opportunity areas', 'Experience principles', 'Problem reframing'],
    image: puzzleImage,
  },
  {
    id: 'shape',
    phase: '04',
    title: 'Shape',
    label: 'Defining the solution',
    body: 'I define solutions that are both desirable and deliverable.',
    outputs: ['Service concepts', 'User journeys', 'Prioritized solution paths'],
    image: collabImage,
  },
  {
    id: 'validate',
    phase: '05',
    title: 'Validate',
    label: 'Testing what matters',
    body: 'I validate direction early through lightweight prototypes and feedback loops.',
    outputs: ['Prototypes', 'Usability insights', 'Iteration decisions'],
    image: postitsImage,
  },
  {
    id: 'launch',
    phase: '06',
    title: 'Launch & Evolve',
    label: 'Driving adoption',
    body: 'I support delivery and adoption to ensure solutions are used and improved over time.',
    outputs: ['Rollout strategy', 'Adoption insights', 'Continuous improvement'],
    image: changeImage,
  },
];
